module.exports = __webpack_public_path__ + "static/media/about03.2ae46983.jpg";